module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Arrow-from-right-31d25b00efd0b9d95bebc4cbe1eb51d8.svg";